import React from 'react';
import PropTypes from 'prop-types';
import SummaryTable from '../summarytable/SummaryTable';

const getCols = (variant) => {
  const cols = [
    { hideOnMobile: false, name: variant === 'asset' ? 'Type' : 'Equipment' },
    { hideOnMobile: true, name: 'Name in BAS' },
    { hideOnMobile: true, name: 'BAS Device', noSort: variant === 'asset' },
    { hideOnMobile: false, name: 'Value' },
    { hideOnMobile: false, name: 'Units' },
  ];

  if (variant === 'sensorType') {
    cols.push({ hideOnMobile: false, name: 'Area Served' });
    cols.push({ hideOnMobile: true, name: 'Location' });
  }

  cols.push({ hideOnMobile: true, name: 'Last Updated' });

  if (variant === 'asset') {
    cols.push({ hideOnMobile: true, name: 'Haystack Tags', noSort: true });
  }

  return cols;
};

const PointTable = ({ points, rowBuilder, variant }) => (
  <SummaryTable
    table={{
      cols: getCols(variant),
      rows: (points || []).map(rowBuilder),
    }}
  />
);

PointTable.propTypes = {
  variant: PropTypes.oneOf(['asset', 'sensorType']).isRequired,
  points: PropTypes.arrayOf(Object).isRequired,
  rowBuilder: PropTypes.func.isRequired,
};

export default PointTable;
